import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next'

import { Form, DatePicker, Button, Card } from 'antd'
import { LoadingOutlined , DownloadOutlined } from '@ant-design/icons'

import vatDocumentActions from '../../redux/vatDocuments/actions'

const { fetchInvoices1688 } = vatDocumentActions
const { RangePicker } = DatePicker

class ExportInvoice1688 extends Component {
    constructor (props) {
        super(props)

        this.formRef = createRef()
    }

    handleSubmit = (e) => {
        const { fetchInvoices1688 } = this.props
        e.preventDefault()

        this.formRef.current.validateFields().then(fieldValue => {
            let startDate = null
            let endDate = null
            if (fieldValue['range_picker']) {
                startDate = fieldValue['range_picker'][0].format('YYYY-MM-DD')
                endDate = fieldValue['range_picker'][1].format('YYYY-MM-DD')
            }

            const values = {
                start_date: startDate,
                end_date: endDate
            }

            fetchInvoices1688(values)
        })
    }

    renderCardHead = () => {
        const { i18n } = this.props

        return (
            <Card.Meta
                title={i18n.t('documents:invoice1688Rport.title')} />
        )
    }

    render () {
        const { vatDocuments, i18n } = this.props
        const loading = vatDocuments.get('invoice1688Loading')
        const formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 }
        }
        const buttonItemLayout = {
            wrapperCol: { span: 14, offset: 4 }
        }
        return (
            <Card title={this.renderCardHead()}
                style={{ margin: '20px 0' }}>
                <Form layout="inline"
                    ref={this.formRef}
                    labelAlign="left"
                    hideRequiredMark>
                    <Form.Item key="search_by_date" label={i18n.t('documents:searchByDate')}
                        name='range_picker'
                        rules={[{
                            required: true,
                            message: i18n.t('documents:pleaseInputDate')
                        }]}
                        {...formItemLayout}>
                            <RangePicker />
                    </Form.Item>
                    <Form.Item key="action_btn" {...buttonItemLayout}>
                        <Button icon={loading ? <LoadingOutlined /> : <DownloadOutlined />}
                            onClick={this.handleSubmit}
                            htmlType="submit">
                                {i18n.t('documents:invoice1688Rport.download')}
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        )
    }
}

const mapStateToProps = state => ({
    vatDocuments: state.get('vatDocuments')
})

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchInvoices1688
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(
    withTranslation('documents')(ExportInvoice1688))
